import PostHelloRequestModelBase from '../_generated/modelBases/post-hello-request-model-base';

export default class PostHelloRequestModel extends PostHelloRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
